export const CHAIN_CONFIGS = {};
